import Activity from "../../activity/model/Activity";
import DragContainerModel from "../../ddTxtImg/model/DragContainerModel";
import ClassificationContainerModel from "./ClassificationContainerModel";

class ClassificationActivity extends Activity {
  constructor() {
    super();
    this.activityType = this.CLASSIFICATION;
    this.dragContainerModel = new DragContainerModel();
    this.ClassificationContainerModel = new ClassificationContainerModel();
  }

  initFromJson = (obj) => {
    this.initPublicItemsFromJson(obj);
    this.dragContainerModel.initFromJson(obj.dragContainerModel);
    this.ClassificationContainerModel.initFromJson(obj.ClassificationContainerModel);
  };

  getAsJson = () => {
    let obj = this.getPublicItemsAsJson();
    obj.dragContainerModel = this.dragContainerModel.getAsJson();
    obj.ClassificationContainerModel = this.ClassificationContainerModel.getAsJson();

    return obj;
  };

  initSharedItems = (activityArr) => {
    this.initPublicSharedItem(activityArr);
  };
}

export default ClassificationActivity;
